import { module as BaseModule } from 'modujs'
import { i18 } from '../utils/dom'

const isDisabled = (element) => element.hasAttribute('disabled')

export default class extends BaseModule {
  async init() {
    this.colors = this.el.querySelectorAll('[data-product-color]')
    this.sizes = this.el.querySelectorAll('[data-product-size]')
    this.cartButton = this.el.querySelector('.snipcart-add-item')
    this.price = this.el.querySelector('[data-product-base-price]')
    this.basePrice = +this.price.innerHTML

    this.productType = this.el.dataset.productType

    this.toggleAttributes('size', 1)
    this.toggleAttributes('color', 2)

    await this.fetchProduct()
    console.log(this.product)

    this.syncStock()
    this.setColorInteractions()
    this.setSizeInteractions()

    if (this.productType === 'variations') this.colors[0].click()
    if (this.productType === 'simple') {
      const matches = [...this.sizes].filter((size) => isDisabled(size) === false)
      if (matches.length > 0) matches[0].click()
    }
  }

  async fetchProduct() {
    try {
      const { itemId } = this.cartButton.dataset
      const apiUrl = `/wp-json/custom/v1/product/${itemId}`

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error('Failed to fetch product information')
      }

      const product = await response.json()
      this.product = product

      return this.product
    } catch (error) {
      this.product = null
      this.disableButton(
        i18(
          'Erreur dans la recherche du produit ',
          'Error fetching product',
          'Fout bij het ophalen van product',
        ),
      )
      return false
    }
  }

  toggleAttributes(attribute, index) {
    const buttons = this[`${attribute}s`]
    if (buttons.length < 2) return

    buttons.forEach((button) => {
      const value = button.querySelector(`[data-product-${attribute}-name]`).innerHTML

      button.addEventListener('click', () => {
        buttons.forEach((b) => {
          b.classList.toggle('is-active', b === button)
        })

        this.cartButton.setAttribute(`data-item-custom${index}-value`, value)
      })
    })
  }

  syncStock() {
    if (!this.product) return

    const { totalStock } = this.product

    if (totalStock === 0) {
      this.disableButton(i18('Rupture de stock', 'Out of stock', 'Uitverkocht'))
      this.sizes.forEach((size) => {
        size.setAttribute('disabled', '')
        size.classList.remove('is-active')
      })
      return
    }

    if (this.productType === 'variations') {
      if (!this.product.variants) return

      const { variants } = this.product

      this.variants = []
      this.colors.forEach((color) => {
        const colorName = color.querySelector('[data-product-color-name]').innerHTML
        const colorExtraPriceHTML = color.querySelector('[data-product-color-price]')
        const colorExtraPrice = colorExtraPriceHTML ? +colorExtraPriceHTML.innerHTML : 0

        const sizes = []
        variants.forEach((variant) => {
          const { stock, variation } = variant
          const c = variation.find((v) => v.name === 'Color')
          const size = variation.find((v) => v.name === 'Size')

          if (c.option === colorName) {
            sizes.push({
              size: size.option,
              stock: stock || 0,
            })
          }
        })

        this.variants.push({
          colorName,
          colorPrice: this.basePrice + colorExtraPrice,
          sizes,
        })
      })
    }

    if (this.productType === 'simple') {
      const { variants } = this.product

      const sizes = []
      this.sizes.forEach((size) => {
        const sizeName = size.querySelector('[data-product-size-name]').innerHTML
        variants.forEach((variant) => {
          const { variation, stock } = variant
          const s = variation.find((v) => v.name === 'Size')

          if (s.option === sizeName) {
            sizes.push({
              sizeName,
              stock: stock || 0,
            })
          }
        })
      })

      sizes.forEach((size) => {
        if (size.stock !== 0) {
          this.sizes.forEach((s) => {
            const sizeName = s.querySelector('[data-product-size-name]').innerHTML
            if (sizeName === size.sizeName) {
              s.removeAttribute('disabled', '')
            }
          })
        }
      })
    }
  }

  setColorInteractions() {
    this.colors.forEach((color) => {
      color.addEventListener('click', () => {
        this.sizes.forEach((size) => {
          size.classList.remove('is-active')
        })

        this.colors.forEach((c) => {
          c.classList.toggle('is-active', c === color)
        })

        const colorName = color.querySelector('[data-product-color-name]').innerHTML
        if (!this.variants) {
          const variantPrice = color.querySelector('[data-product-color-price]')
            ? +color.querySelector('[data-product-color-price]').innerHTML
            : 0
          this.price.innerHTML = this.basePrice + variantPrice
          return
        }

        const variant = this.variants.find((v) => v.colorName === colorName)
        if (!variant) return

        this.disableButton(i18('Choisissez une taille', 'Choose a size', 'Kies een maat'))

        this.cartButton.setAttribute('data-item-custom2-value', colorName)

        const allSizesOutOfStock = variant.sizes.every((size) => size.stock === 0)
        if (allSizesOutOfStock) {
          this.sizes.forEach((size) => {
            size.setAttribute('disabled', '')
            size.classList.remove('is-active')
          })
          this.cartButton.innerHTML = i18('Rupture de stock', 'Out of stock', 'Uitverkocht')
          return
        }

        variant.sizes.forEach((size) => {
          this.sizes.forEach((s) => {
            const sizeName = s.querySelector('[data-product-size-name]').innerHTML
            const match = sizeName === size.size

            if (match) {
              if (size.stock === 0) {
                s.setAttribute('disabled', '')
              } else {
                s.removeAttribute('disabled')
              }
            } else {
              s.setAttribute('disabled', '')
            }
          })
        })

        this.price.innerHTML = variant.colorPrice
      })
    })
  }

  setSizeInteractions() {
    if (!this.product) return

    this.sizes.forEach((size) => {
      size.addEventListener('click', () => {
        if (size.hasAttribute('disabled')) return

        this.sizes.forEach((s) => {
          s.classList.toggle('is-active', s === size)
        })

        const sizeName = size.querySelector('[data-product-size-name]').innerHTML

        this.enableButton(i18('Add to cart', 'Add to cart', 'Toevoegen aan winkelmand'))
        this.cartButton.setAttribute('data-item-custom1-value', sizeName)
      })
    })
  }

  enableButton(message) {
    this.cartButton.removeAttribute('disabled', '')
    this.cartButton.innerHTML = message
  }

  disableButton(message) {
    this.cartButton.setAttribute('disabled', '')
    this.cartButton.innerHTML = message
  }
}
